import React from 'react';
import { useAuth } from './common/Auth';
import { useTheme } from './context/ThemeContext';
import UserAvatar from './components/UserAvatar';
import { Sun, Moon, Monitor, LogOut } from 'lucide-react';
import { auth } from './common/firebase';
import { signOut } from 'firebase/auth';

const Account = () => {
	const currentUser = useAuth();
	const { theme, resolvedTheme, setTheme } = useTheme();

	const options = [
		{ key: 'light', label: 'Light', icon: Sun, desc: 'Always light' },
		{ key: 'dark', label: 'Dark', icon: Moon, desc: 'Always dark' },
		{ key: 'system', label: 'System', icon: Monitor, desc: 'Follow device' }
	];

	return (
		<div className="p-4 sm:p-6 max-w-xl mx-auto">
			<h1 className="text-xl sm:text-2xl font-semibold tracking-tight mb-4">Account</h1>

			{/* User info */}
			<div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-2xl p-6 mb-4">
				<div className="flex items-center gap-4 mb-4">
					<UserAvatar user={currentUser} size={56} />
					<div>
						<div className="font-semibold text-lg">{currentUser?.first} {currentUser?.last}</div>
						<div className="text-sm text-gray-500 dark:text-gray-400">{currentUser?.email}</div>
					</div>
				</div>
			</div>

			{/* Appearance / Theme preference */}
			<div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-2xl p-6">
				<div className="mb-4">
					<div className="text-sm font-medium">Appearance</div>
					<div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
						Choose how the interface looks. Current: <span className="font-medium capitalize">{resolvedTheme}</span>
					</div>
				</div>

				<div className="flex flex-wrap gap-2">
					{options.map(({ key, label, icon: Icon }) => {
						const active = theme === key;
						return (
							<button
								key={key}
								onClick={() => setTheme(key)}
								className={`flex-1 min-w-[92px] flex items-center justify-center gap-2 px-4 py-2.5 text-sm rounded-xl border transition-all ${
									active
										? 'bg-[#880e4f] text-white border-[#880e4f] shadow-sm'
										: 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-950 hover:bg-gray-50 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-300'
								}`}
								aria-pressed={active}
							>
								<Icon size={16} />
								<span>{label}</span>
							</button>
						);
					})}
				</div>

				<div className="mt-3 text-[11px] text-gray-500 dark:text-gray-400">
					"System" follows your operating system or browser preference.
				</div>
			</div>

			<div className="mt-4 text-xs text-gray-400">
				More settings (notifications, billing, etc.) can be added here.
			</div>

			<button
				onClick={() => signOut(auth)}
				className="mt-6 w-full sm:w-auto inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm rounded-xl border border-red-200 dark:border-red-900 text-red-600 hover:bg-red-50 dark:hover:bg-red-950 transition-colors"
			>
				<LogOut size={16} /> Sign Out
			</button>
		</div>
	);
};

export default Account;